import { PublicBrandShell } from '../../components/public/PublicBranding';
import { IN_APP_FOOTER_LINKS } from './publicFooterLinks';

const PADDLE_SUPPORT_URL = 'https://www.paddle.com/help/manage/your-customers/buyers-refunds';

export default function ContactPage() {
  return (
    <PublicBrandShell footerLinks={IN_APP_FOOTER_LINKS}>
      <div className="min-h-screen bg-[#0B0E08] text-[#A8AE9E]">
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <h1 className="text-3xl font-bold text-gray-200 mb-2">Contact</h1>
          <p className="text-xs text-[#7E8473] mb-8">We&apos;re happy to help with any question.</p>

          <div className="space-y-6 text-sm">
            <section>
              <h3 className="text-lg font-semibold text-gray-200 mb-3">Get in touch</h3>
              <p className="mb-3">
                For product questions, support, account help, or privacy requests, email us at{' '}
                <a href="mailto:contact@kolega.ai" className="text-[#ADDD30] hover:underline">contact@kolega.ai</a>.
                We aim to respond within one business day.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-200 mb-3">Company details</h3>
              <div className="bg-[#21281A]/50 p-4 rounded-lg">
                <p className="font-medium text-gray-200">KLG Tech Innovations Limited</p>
                <p>Val Verclut, La Route des Cotils</p>
                <p>Grouville, JE3 9AP, Jersey</p>
                <p>
                  Email: <a href="mailto:contact@kolega.ai" className="text-[#ADDD30] hover:underline">contact@kolega.ai</a>
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-200 mb-3">Billing &amp; payments</h3>
              <p className="mb-3">
                Payments are processed by Paddle, who acts as our Merchant of Record. For invoices, receipts, or
                payment-method questions, contact us at{' '}
                <a href="mailto:contact@kolega.ai" className="text-[#ADDD30] hover:underline">contact@kolega.ai</a>, or use
                the{' '}
                <a href={PADDLE_SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="text-[#ADDD30] hover:underline">
                  Paddle Order Support Portal
                </a>
                . See our{' '}
                <a href="/refund" className="text-[#ADDD30] hover:underline">Refund Policy</a> for cancellations and refunds.
              </p>
            </section>
          </div>
        </main>
      </div>
    </PublicBrandShell>
  );
}
